// shame.js

(function ($) {
  if ($(".meta-top .banner-image, .meta-top .mediagallery, .meta-top figure.asset-audio, .meta-top figure.asset-video").length !== 0) {
    //Es gibt ein Bannerbild an der Stelle, die das JSON definiert hat.
    //Bannerbild an falscher Stelle wird entfernt:
    $(".detail > .aquarium-panoramateaser .banner-image, .detail > .aquarium-panoramateaser .mediagallery, .detail > .aquarium-panoramateaser figure.asset-audio, .detail > .aquarium-panoramateaser figure.asset-video").remove();
  }
})(window.jQuery);

// SWRONL-13843
// Fokusmanagement für Sprungmarken, die auf Anker-Elemente verweisen, die nicht fokussierbar sind (z. B. <a name="...">).
document.addEventListener("click", (event) => {
  const link = event.target.closest('a[href^="#"]');
  if (!link) {
    return;
  }

  const targetName = link.getAttribute("href").slice(1);

  setTimeout(() => {
    const anchor = document.querySelector(`a[name="${CSS.escape(targetName)}"]`);

    const heading = anchor?.closest("h2");

    if (heading) {
      heading.tabIndex = -1;
      heading.focus();
    }
  }, 0);
});
